export default __webpack_public_path__ + "static/media/tacos.7fc97728.jpg";